<template>
	<div style="background-color: white; max-width: 900px; margin: 5em auto; padding: 5em 3em; text-align: justify;">
		<div class="back_to_home_box">
			<router-link class="back_to_home" to="/#contacts">
				&times;
			</router-link>
		</div>
		<div class="static_view_content" v-html="content"></div>
	</div>
</template>

<script>
export default {
	props: {'content': String},
	name: "StaticViewComponent"
}
</script>

<style scoped>
.back_to_home_box {
	position: fixed;
	right: 15px;
	top: 15px;
	z-index: 1000;
}


.back_to_home,
.back_to_home:hover {
	color: white;
    position: relative;
    text-decoration: none;
    font-size: 70px;
    height: 45px;
    right: 0;
    top: 0;
    width: 45px;
    /* line-height: 100px; */
    opacity: 0.9;
    text-shadow: 0px 0px 5px black;
}


.back_to_home:hover {
	opacity: 0.5;
}

p { text-indent: 2em; }
</style>